import React, { useState } from 'react'
import { Dialog, DialogContent, Grid } from '@mui/material'
import { BasicDialogAction, BasicDialogTitle } from 'common/components/modal/DialogComponents'
import { orderBy } from 'lodash'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useOutletContext, useParams } from 'react-router'
import useTitles from 'common/hooks/useTitles'
import NoteCard from '../../notes/NoteCard'
import useNoteTypeOptions from '../../notes/useNoteTypeOptions'
import moment from 'moment'
import { updateNote, deleteNote, createNote } from 'gdl/notes/NotesSlice'
import { NEW } from 'common/components/action/ActionConstant'
import useActions from 'common/hooks/useActions'

const CustomerNotesApp = () => {
    const [openNotePopin, setOpenNotePopin] = useState(false)
    const creationLogin = useSelector(store => store.app.user?.login, shallowEqual)
    const [noteToEdit, setNoteToEdit] = useState()

    const { id } = useParams()
    const { customer, notes, reloadNotes } = useOutletContext()
    const dispatch = useDispatch()
    const noteTypeOptions = useNoteTypeOptions()

    useTitles(() => [{
        label: 'Clients',
        href: '/customer',
    }, {
        label: customer?.name ?? 'Inconnu',
        href: `/customer/${id}`,
    }, {
        label: 'Notes',
        href: `/customer/${id}/notes`,
    }], [id, customer])


    useActions(() => [{
        type: NEW,
        onClick: () => {
            setOpenNotePopin(true)
            setNoteToEdit({ idClient: customer?.id, creationDate: moment().valueOf(), creationLogin })
        },
    }], [])


    return (
        <Grid container spacing={1} justifyContent='center'>
            {orderBy(notes ?? [], ['creationDate'], ['desc'])?.map(note => (
                <Grid size={8} key={note.id}>
                    <NoteCard
                        note={note}
                        readMode
                        contextActions={[{
                            label: 'Modifier la note',
                            onClick: () => {
                                setNoteToEdit(note)
                                setOpenNotePopin(true)
                            },
                            icon: 'edit',
                        }, {
                            label: 'Supprimer la note',
                            onClick: () => {
                                dispatch(deleteNote(note.id)).then(() => {
                                    reloadNotes()
                                })
                            },
                            icon: 'delete',
                        }]}
                    />
                </Grid>
            ))}
            {openNotePopin && (
                <Dialog
                    open={openNotePopin}
                    maxWidth='md'
                >
                    <BasicDialogTitle onClose={() => setOpenNotePopin(false)}>
                        Nouvelle note
                    </BasicDialogTitle>
                    <DialogContent>
                        <NoteCard
                            note={noteToEdit}
                            onChange={setNoteToEdit}
                            typeOptions={noteTypeOptions}
                        />
                    </DialogContent>
                    <BasicDialogAction
                        buttonLabel={'Valider'}
                        onValidate={() => dispatch(noteToEdit?.id ? updateNote(noteToEdit) : createNote(noteToEdit)).then(() => {
                            setOpenNotePopin(false)
                            setNoteToEdit()
                            reloadNotes()
                        })}
                        isDisabled={!noteToEdit?.typeNote || !noteToEdit?.comment || !noteToEdit?.creationDate}
                    />
                </Dialog>
            )}
        </Grid>
    )
}

export default CustomerNotesApp